import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Modal,
  Image,
  Button
} from '@lockerpm/design';

import images from "../../assets/images";

import global from "../../config/global";
import storeActions from "../../store/actions";
import onboardingServices from "../../services/onboarding";

const WelcomeModal = () => {
  const { t } = useTranslation();
  const { WelcomeImg } = images;

  const showTutorial = useSelector((state) => state.onboarding.showTutorial)

  const onClose = () => {
    global.store.dispatch(storeActions.updateShowTutorial(false));
  }

  const startWelcomeTour = () => {
    global.navigate(global.keys.WELCOME_TOUR);
    onClose();
  }

  const handleSkip = async () => {
    await onboardingServices.update_onboarding({ tutorial: true });
    onClose();
  }
  
  return (
    <Modal
      open={showTutorial}
      onCancel={onClose}
      width={450}
      footer={false}
      closeIcon={<></>}
    >
      <div className="flex flex-col items-center">
        <h1 className="font-medium text-[28px] text-black">
          {t('welcome.title')}
        </h1>
        <Image
          height={256}
          src={WelcomeImg}
          preview={false}
        />
        <p className="text-lg text-black text-center mb-8" style={{ maxWidth: 350 }}>
          {t('welcome.desc')}
        </p>
        <Button
          type="primary"
          onClick={() => startWelcomeTour()}
        >
          {t('welcome.start')}
        </Button>
        <Button type="text" className="mt-3" onClick={() => handleSkip()}>
          {t('welcome.skip')}
        </Button>
      </div>
    </Modal>
  );
}

export default WelcomeModal;